import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'overview', pathMatch: 'full' },
            {
                path: 'overview',
                loadComponent: () => import('./screens/overview/overview.component').then(m => m.OverviewComponent)
            },
            {
                path: 'directory',
                loadComponent: () => import('./screens/directory/directory.component').then(m => m.DirectoryComponent)
            },
            {
                path: 'add',
                loadComponent: () => import('./screens/add-student/add-student.component').then(m => m.AddStudentComponent)
            },
            {
                path: 'promotion',
                loadComponent: () => import('./screens/promotion/promotion.component').then(m => m.PromotionComponent)
            },
            {
                path: 'transfers',
                loadComponent: () => import('./screens/transfers/transfers.component').then(m => m.TransfersComponent)
            },
            {
                path: 'import',
                loadComponent: () => import('./screens/import/import.component').then(m => m.ImportComponent)
            },
            {
                path: 'compliance',
                loadComponent: () => import('./screens/compliance/compliance.component').then(m => m.ComplianceComponent)
            },
            {
                path: 'alumni',
                loadComponent: () => import('./screens/alumni/alumni.component').then(m => m.AlumniComponent)
            },
            {
                path: 'reports',
                loadComponent: () => import('./screens/reports/reports.component').then(m => m.ReportsComponent)
            },
            {
                path: 'settings',
                loadComponent: () => import('./screens/settings/settings.component').then(m => m.SettingsComponent)
            },
            {
                path: 'students/:id',
                loadComponent: () => import('./screens/student-360/student-360.component').then(m => m.Student360Component)
            }
        ]
    },
    { path: '**', redirectTo: '' }
];
